import React, { useEffect, useRef, useState } from "react";
import allApi from "../../../../api/allApi";
import ReactSlider from "react-slider";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useLocalization } from "../../localization/LocalizationContext";

function LoadBalancing({networkId}) {
  const {localizationStrings} = useLocalization();
  const [load, setLoad] = useState();
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [sliderValues, setSliderValues] = useState({
    maxClients: [5, 5],
    clientRSSI: [1, 1],
    channelUtilization: [50, 50],
    stickyClients: [-90, -90],
  });

  const [showSliders, setShowSliders] = useState({
    maxClients: false,
    clientRSSI: false,
    channelUtilization: false,
    stickyClients: false,
  });
  const [headingValues,setHeadingValues] = useState({
   loadBalancingStatus: 0,
   stickyClient: 0, 
  });
  const [showHeaders,setShowHeaders] = useState({
    loadBalancingStatus: false,
    stickyClient: false,
  })
  const initialDataRef = useRef(null);

  useEffect(()=>{
  getLoadBalancing(networkId);
  },[networkId]);

  const handleCancelPopUp = () => {
    setShowSuccessPopup(false);
    getLoadBalancing(networkId);
  }

  const getLoadBalancing = async () => {
    try {
      const api = new allApi();
      const response = await api.getRequest(`api/wireless/getLoadBalance?networkId=${networkId}`);
      if (response && response.response) {
        const data = response.response;
  
        // Set the load data
        setLoad(data);
        const clamp = (n, min, max, fallback) => {
          const value = parseInt(n, 10);
          if (Number.isNaN(value)) return fallback;
          return Math.min(max, Math.max(min, value));
        };
        const sliders = {
          maxClients: [
            clamp(data.maxClientPerRadio.wlan0, 5, 200, 5),
            clamp(data.maxClientPerRadio.wlan1, 5, 200, 5),
          ],
          clientRSSI: [
            clamp(data.rxRssi.wlan0, 1, 50, 1),
            clamp(data.rxRssi.wlan1, 1, 50, 1),
          ],
          channelUtilization: [
            clamp(data.channelUtilization.wlan0, 50, 90, 50),
            clamp(data.channelUtilization.wlan1, 50, 90, 50),
          ],
          stickyClients: [
            clamp(data.stickyClients.wlan0, -90, -85, -90),
            clamp(data.stickyClients.wlan1, -90, -85, -90),
          ],
        };
        const headers = {
          loadBalancingStatus: data.loadBalancingStatus,
          stickyClient: data.stickyClient,
        };

        setSliderValues(sliders);
        setHeadingValues(headers);
  
        // Map the API status to showSliders
        setShowSliders({
          maxClients: !!data.maxClientPerRadio.status,
          clientRSSI: !!data.rxRssi.status,
          channelUtilization: !!data.channelUtilization.status,
          //stickyClients: !!data.stickyClients.status,
        });
        setShowHeaders({
          loadBalancingStatus: !!data.loadBalancingStatus,
          stickyClient: !!data.stickyClient
        })
        initialDataRef.current = {
          sliders, headers, showSliders: {
            maxClients: !!data.maxClientPerRadio.status,
            clientRSSI: !!data.rxRssi.status,
            channelUtilization: !!data.channelUtilization.status,
          },
          showHeaders: {
            loadBalancingStatus: !!data.loadBalancingStatus,
            stickyClient: !!data.stickyClient
          }
        };
      }
    } catch (error) {
      console.error("Error fetching load balance", error);
    }
  };

  const hasChanges = () => {
    if (!initialDataRef.current) return false;

    const { sliders, headers, showSliders: initShow, showHeaders: initHeader } = initialDataRef.current;
    const slidersChanged = Object.keys(sliderValues).some((key) =>
      sliderValues[key].some((val, i) => val !== sliders[key][i])
    );
    const headersChanged = Object.keys(headingValues).some(
      (key) => headingValues[key] !== headers[key]
    );
    const showChanged =
      JSON.stringify(showSliders) !== JSON.stringify(initShow);
    const showHeaderChanged =
      JSON.stringify(showHeaders) !== JSON.stringify(initHeader);

    return slidersChanged || headersChanged || showChanged || showHeaderChanged;
  };  

  const inputLoadBalance = async() =>{
    try{
     const api = new allApi();
     const payload = {
      loadBalancingStatus : showHeaders.loadBalancingStatus ? 1 : 0,
      stickyClient : showHeaders.stickyClient ? 1 : 0,
      channelUtilization:{
          status :showSliders.channelUtilization ? 1 : 0,
          wlan0: sliderValues.channelUtilization[0].toString(),
          wlan1: sliderValues.channelUtilization[1].toString(),
          //wlan2: sliderValues.channelUtilization[2].toString(),
          //wlan2_6: sliderValues.channelUtilization[3].toString()
  
      },
      maxClientPerRadio:{
           status : showSliders.maxClients ? 1 : 0,
          wlan0: sliderValues.maxClients[0].toString(),
          wlan1: sliderValues.maxClients[1].toString(),
          //wlan2: sliderValues.maxClients[2].toString(),
          //wlan2_6: sliderValues.maxClients[3].toString()
      },
      rxRssi:{
           status :showSliders.clientRSSI ? 1 : 0,
          wlan0: sliderValues.clientRSSI[0].toString(),
          wlan1: sliderValues.clientRSSI[1].toString(),
          //wlan2: sliderValues.clientRSSI[2].toString(),
          //wlan2_6: sliderValues.clientRSSI[3].toString()
      },
      stickyClients:{
          status :showSliders.stickyClients ? 1: 0,
          wlan0: sliderValues.stickyClients[0].toString(),
          wlan1: sliderValues.stickyClients[1].toString(),
          //wlan2: sliderValues.stickyClients[2].toString(),
          //wlan2_6: sliderValues.stickyClients[3].toString()
      }
     };
     const response = await api.postRequest(`api/wireless/loadBalance?networkId=${networkId}`,"",payload);
     if(response){
      setShowSuccessPopup(true);
      console.log("Successfully set Load Balancing",response);
     }
    }catch(error){
     console.error("Error in input load",error);
    }
  };

  // Handle slider value change
  const handleSliderChange = (field, index, value) => {
    setSliderValues((prevValues) => ({
      ...prevValues,
      [field]: prevValues[field].map((val, i) => (i === index ? value : val)),
    }));
  };

  const toggleSliders = (field) => {
    setShowSliders((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };
  const toggleHeaders = (field) => {
    setShowHeaders((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const renderSliders = (field) => {
    const sliderRanges = {
      maxClients: { min: 5, max: 200 },
      clientRSSI: { min: 1, max: 50 },
      channelUtilization: { min: 50, max: 90 },
      stickyClients: [
        { min: -90, max: -85 }, // wlan0 range
        { min: -90, max: -85 }, // wlan1 range
      ],
    };
  
    return (
      <div style={{ margin: "40px 0" }}>
        {sliderValues[field].map((value, index) => {
          // Determine the slider range dynamically
          const range =
            field === "stickyClients" ? sliderRanges.stickyClients[index] : sliderRanges[field];
  
          return (
            <div key={index} className="load-slider">
              <span>
                {index === 0
                  ? "2.4 GHz"
                  : index === 1
                  ? "5 GHz"
                  : index === 2
                  ? "5 GHz High"
                  : "6 GHz"}
              </span>
              <div className="slider-value">
                <span>{range.min}</span>
                <ReactSlider
                  min={range.min}
                  max={range.max}
                  value={value}
                  onChange={(val) => handleSliderChange(field, index, val)}
                  className="custom-slider"
                  thumbClassName="custom-thumb"
                  trackClassName="custom-track"
                  renderThumb={(props, state) => (
                    <div {...props} className="custom-thumb">
                      {state.valueNow}
                    </div>
                  )}
                  renderTrack={(props, state) => (
                    <div
                      {...props}
                      style={{
                        ...props.style,
                      }}
                    />
                  )}
                />
                <span>{range.max}</span>
              </div>
            </div>
          );
        })}
      </div>
    );
  };  
  
  
  

  return (
    <div className="w-scroll">
      <p>
        {localizationStrings?.loadInfo}
      </p>

      <div className="tab-form">
        {/* Load Balancing */}
        <div className="row mb-4">
          <div className="col-lg-6">
            <div className="switch-box">
              <strong>{localizationStrings?.loadBalancing}</strong>
              <label className="ice-switch">
                <input type="checkbox" 
                checked={showHeaders.loadBalancingStatus}
                onChange={()=>toggleHeaders("loadBalancingStatus")}
                />
                <span className="slider"></span>
              </label>
            </div>
          </div>
        </div>
         {showHeaders.loadBalancingStatus && (
        <div style={{ marginBottom: "20px" }}>
          <div className="load-list">
            <div className="load-type">
              <label className="checkbox">
                <input
                  type="checkbox"
                  checked={showSliders.maxClients}
                  onChange={() => toggleSliders("maxClients")}
                />
                <span className="indicator"></span>
                <p>{localizationStrings?.maxClientInfo}</p>
              </label>
            </div>
            {showSliders.maxClients && renderSliders("maxClients")}
          </div>

          {/* Balance on client Rx RSSI */}
          <div className="load-list">
            <div className="load-type">
              <label className="checkbox">
                <input
                  type="checkbox"
                  checked={showSliders.clientRSSI}
                  onChange={() => toggleSliders("clientRSSI")}
                />
                <span className="indicator"></span>
                <p>{localizationStrings?.clientRssiInfo}</p>
              </label>
            </div>
            {showSliders.clientRSSI && renderSliders("clientRSSI")}
          </div>

          {/* Balance on channel utilization */}
          <div className="load-list">
            <div className="load-type">
              <label className="checkbox">
                <input
                  type="checkbox"
                  checked={showSliders.channelUtilization}
                  onChange={() => toggleSliders("channelUtilization")}
                />
                <span className="indicator"></span>
                <p>{localizationStrings?.channelInfo}</p>
              </label>
            </div>
            {showSliders.channelUtilization && renderSliders("channelUtilization")}
          </div>
        </div>
         )}
        {/* Disassociate sticky clients */}
        <div className="row mb-4 mt-4">
          <div className="col-lg-6">
            <div className="switch-box">
              <strong>{localizationStrings?.stickyClients}</strong>
              <label className="ice-switch">
                <input
                  type="checkbox"
                  checked={showHeaders.stickyClient}
                  onChange={() => toggleHeaders("stickyClient")}
                />
                <span className="slider"></span>
              </label>
            </div>
          </div>
        </div>
        {showHeaders.stickyClient && (
          <p>{localizationStrings?.stickyInfo}</p>
        )}
        {showHeaders.stickyClient && renderSliders("stickyClients")}
      </div>
      <div className="wifi-footer">
        <button
          type="button"
          className="btn btn-outline"
          onClick={() => {
            if (!initialDataRef.current) return;
            const { sliders, headers, showSliders: initShow, showHeaders: initHeader } =
              initialDataRef.current;
            setSliderValues(sliders);
            setHeadingValues(headers);
            setShowSliders(initShow);
            setShowHeaders(initHeader);
          }}
        >
          {localizationStrings?.cancel}
        </button>
        <button type="submit" className="text-btn primary-btn" onClick={()=>inputLoadBalance(networkId)}
          disabled= {!hasChanges()}>{localizationStrings?.save}</button>
      </div>
      <Modal
        show={showSuccessPopup}
        onHide={handleCancelPopUp}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="inc-alert index-2000"
      >
        <span className="success-icon">
          <i className="icon done"></i>
        </span>
        <h3>{localizationStrings?.success}</h3>
        <p>{localizationStrings?.loadBalanceChangedSuccessfully}</p>
        <Button onClick={handleCancelPopUp}>
          {localizationStrings?.ok}
        </Button>
      </Modal>
    </div>
  );
}

export default LoadBalancing;
